<template>
    <Dialog v-model="value" :title="title" @input="$listeners.input" :show-close-button="showCloseButton" width="450">
        <template v-slot:title>
            <span class="dialog_hierarquia_title">{{ title }}</span>
        </template>
        <v-form class="dont_apply_primary_color" ref="formGNRC" @submit.prevent="showConfirmation()">
            <Autocomplete id="gerenteNegocioSelect"
                          label="Gerente de Negócio ou Regional Comercial:"
                          class="required icone_cor_padrao"
                          v-model="hierarchyAssistent"
                          color="default_accent_color"
                          item-color="default_secodary_color"
                          :items="load"
                          :menu-props="{ contentClass: 'rolagemEd' }"
                          :hide-selected="false"
                          item-value="value"
                          item-text="label"
                          :cache-items="false"
                          placeholder="Selecione um GN/RC"
                          :rules="[$rules.required]"
            />
            <div class="d-flex justify-center mt-4">
                <v-btn color="default_primary_color" style="color:#fff" rounded @click="showConfirmation()">
                    Confirmar
                </v-btn>
            </div>
            <v-form />
        </v-form>
    </Dialog>
</template>

<script>
  import commercialHierarchy from '@/mixins/commercialHierarchy'
  import { notification } from '../../plugins/helpers'
  export default {
    name: 'DialogCommercialHierarchyAssistentLogin',
    mixins: [commercialHierarchy],
    props: {
      value: { type: Boolean, default: true },
      items: { type: Object, default: () => {} },
      logando: { type: Boolean, default: true },
      showCloseButton: { type: Boolean, default: true }
    },
    data: () => ({
      title: 'Selecione um GN/RC',
      hierarchyAssistent: null
    }),
    computed: {
      load () {
        return this.buildRcOrGnForAssistent()
      },
      showDialog: {
        get () {
          return this.dialog
        },
        set (val) {
          this.$emit('dialog', val)
        }
      }

    },
    watch: {
      'items.listaGerenteNegocio' () {
        if (!this.logando) {
          return
        }
        const items = this.buildRcOrGnForAssistent()
        if (items.length === 1) {
          this.$emit('input', false)
          this.hierarchyAssistent = items[0].value
          this.confirm()
        }
      }
    },
    methods: {
      showConfirmation () {
        const form = this.$refs.formGNRC
        if (form.validate()) {
          this.confirm()
        }
      },
      buildRcOrGnForAssistent () {
        if (this.$props?.items?.hierarquia_assistente) {
          return this.$props.items.hierarquia_assistente.map(item => {
            return { 'label': `${item.link_comercial}`, value: item.codigo_gn_ou_rc }
          })
        } else {
          return []
        }
      },
      confirm () {
        const codigo_assistente = this.hierarquia_comercial.codigo_assistente
        const nome_assistente = this.hierarquia_comercial.nome_assistente
        const idEstruturaComercial = this.hierarquia_comercial.idEstruturaComercial
        this.$session.set('hierarquia_comercial', null)

        this.$http.post('/consultHierarchyAssistent', { codigo_gn_ou_rc: this.hierarchyAssistent, codigo_assistente: codigo_assistente, idEstruturaComercial: idEstruturaComercial })
          .then(result => {
            this.$session.set('hierarquia_comercial', {
              ...result.data.hierarquia_comercial,
              codigo_assistente: codigo_assistente,
              nome_assistente: nome_assistente
            })
            this.$emit('validateHierarchyReturn', result)
            this.$emit('input', false)
          }).catch(err => notification('error', err, 'Não foi possível carregar a hierarquia assistente!'))
      }
    }
  }
</script>

<style scoped>

.dialog_hierarquia_title {
    width: 100%;
    font-size: 1.2rem;
    text-transform: uppercase;
    color: var(--default_secodary_color);
    text-align: center;
}
</style>

<style>
.rolagemEd::-webkit-scrollbar-thumb{
    background: #5FBEE3 !important;
}
#gerenteNegocioSelect > div > div.v-input__slot > div.v-select__slot > div:nth-child(4) > div > i {
    color:#5FBEE3 !important;
}
</style>
